import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  ContentContainer,
  Text,
  ButtonNext,
  ButtonBack,
  Input,
  Buttons,
  UploadButton,
  RowInputLast,
  UploadedPhotosContainer,
  SmallText,
  UploadCard,
  HeaderCard,
  LeftIcons,
  TextArea,
  Image,
  ColumnInput,
  StyledRow,
  RowPriceContainer,
  PriceWithVatText,
  ButtonGenerate,
  Relative,
} from "../Steps.styles";

import { useTranslation } from "react-i18next";
import { ReactComponent as Checked } from "../../../assets/icons/checkbox-fill.svg";
import { ReactComponent as Unchecked } from "../../../assets/icons/checkbox-blank-line.svg";
import { ReactComponent as PromptSvg } from "../../../assets/icons/prompt.svg";
import { ReactComponent as AiSvg } from "../../../assets/icons/ai.svg";
import { ReactComponent as Upload } from "../../../assets/icons/upload2.svg";
import { ReactComponent as Loading } from "../../../assets/icons/loader.svg";
import UseAnimations from "react-useanimations";
import trash2 from "react-useanimations/lib/trash2";
import { useDispatch } from "react-redux";
import {
  addItemName,
  addItemPrice,
  setName,
  setPrice,
  addItemDisplayPhoto,
  setDisplayPhoto,
  addItemPhotos,
  setUrlPhotos,
  addItemDescription,
  setDescription,
  addItemArabicName,
  setArabicName,
  addItemArabicDescription,
  setArabicDescription,
  addItemPrintAreas,
  setItemAIPhotos,
  selectItemAIPhotos,
  setPrintAreasToStore,
} from "../../../store/slices/marketplace/marketplaceSlice";
import { useSelector } from "react-redux";
import openToast from "../../../utils/toast";
import { formatFileID, priceFormatter } from "../../../utils/utils";
import {
  generateItemDescription,
  generateItemPhotos,
} from "../../../store/slices/marketplace/asyncThunks";
import {
  BACKGROUND_PROMPT,
  PACKAGING_IMAGE_PROMPT,
  REAL_LIFE_IMAGE_PROMPT,
} from "../../../utils/constants";
import CustomPromptModal from "../../CustomPromptModal/CustomPromptModal";
import Tooltip from "../../Tooltip";

const AddItemStepItemsInfo = ({
  onNext,
  onBack,
  setPhotos,
  photos,
  photosToList,
  setPhotosToList,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const name = useSelector(addItemName);
  const arabicName = useSelector(addItemArabicName);
  const price = useSelector(addItemPrice);
  const description = useSelector(addItemDescription);
  const arabicDescription = useSelector(addItemArabicDescription);
  const addItemPhotosArr = useSelector(addItemPhotos);
  const displayPhoto = useSelector(addItemDisplayPhoto);
  const printAreasStore = useSelector(addItemPrintAreas);

  const toastId = useRef(null);

  const aIPhotos = useSelector(selectItemAIPhotos);

  const [urlPhotosToList, setUrlPhotosToList] = useState([]);
  const [generateLoading, setGenerateLoading] = useState(false);
  const [generateDescriptionLoading, setGenerateDescriptionLoading] =
    useState(false);

  const [openPromptModal, setOpenPromptModal] = useState(false);

  const [packagingPrompt, setPackagingPrompt] = useState(
    PACKAGING_IMAGE_PROMPT
  );
  const [realLifePrompt, setRealLifePrompt] = useState(REAL_LIFE_IMAGE_PROMPT);
  const [backgroundPrompt, setBackgroundPrompt] = useState(BACKGROUND_PROMPT);

  useEffect(() => {
    if (!addItemPhotosArr?.length) return;

    const filteredArr =
      aIPhotos?.length > 0
        ? addItemPhotosArr.filter(
            (photo) => !aIPhotos.some((p) => p === photo.url)
          )
        : addItemPhotosArr;

    setUrlPhotosToList(filteredArr);
  }, [aIPhotos, addItemPhotosArr]);

  const handleClick = (index, type) => {
    let id = null;

    if (type === "ai") {
      const url = aIPhotos[index];
      id = url;

      if (!addItemPhotosArr.some((p) => p.url === url)) {
        const updated = [...addItemPhotosArr, { url }];
        dispatch(setUrlPhotos(updated));
      }
    } else if (type === "url") {
      const url = addItemPhotosArr[index].url;
      id = url;
    } else if (type === "file") {
      const file = photosToList[index];
      id = formatFileID(file);
      if (!photos.some((p) => p.name === file.name && p.size === file.size)) {
        const updated = [...photos, file];
        setPhotos(updated);
      }
    }
    if (displayPhoto?.id === id && displayPhoto?.type === type) {
      dispatch(setDisplayPhoto(null));
    } else {
      dispatch(setDisplayPhoto({ type, id }));
    }
  };

  const handleRemoveAIPhotoFromDisplay = (aiPhotoUrl) => {
    const updatedPhotos = addItemPhotosArr.filter((p) => p.url !== aiPhotoUrl);
    dispatch(setUrlPhotos(updatedPhotos));

    removePrintArea(aiPhotoUrl);

    if (displayPhoto?.id === aiPhotoUrl) {
      dispatch(setDisplayPhoto(null));
    }

    const updatedAIPhotos = aIPhotos.filter((p) => p !== aiPhotoUrl);
    dispatch(setItemAIPhotos(updatedAIPhotos));

    setUrlPhotosToList((prev) => prev.filter((p) => p.url !== aiPhotoUrl));

    setPhotosToList((prev) =>
      prev.filter((file) => formatFileID(file) !== aiPhotoUrl)
    );

    setPhotos((prev) =>
      prev.filter((file) => formatFileID(file) !== aiPhotoUrl)
    );
  };

  const handleFileUpload = (files) => {
    const updatedFiles = [...photosToList];
    for (let i = 0; i < files.length; i++) {
      updatedFiles.push(files[i]);
    }
    setPhotosToList(updatedFiles);
    // setPhotos(updatedFiles);
  };

  const handleAddPhotoFile = (file) => {
    const updatedFiles = [...photos, file];
    setPhotos(updatedFiles);
  };
  const removePrintArea = useCallback(
    (photoId) => {
      if (!photoId) return;

      const tmp = { ...printAreasStore };

      if (tmp[photoId]) {
        delete tmp[photoId];
        dispatch(setPrintAreasToStore(tmp));
      }
    },
    [printAreasStore, dispatch]
  );

  const handleRemovePhotoFile = (file) => {
    const fileIndex = photos.findIndex(
      (p) => p.name === file.name && p.size === file.size
    );

    if (fileIndex === -1) return;

    const updatedFiles = photos.filter(
      (p) => !(p.name === file.name && p.size === file.size)
    );
    setPhotos(updatedFiles);
    const fileId = formatFileID(file);

    removePrintArea(fileId);

    if (displayPhoto?.type === "file" && displayPhoto?.id === fileId) {
      dispatch(setDisplayPhoto(null));
    }
  };

  const handleRemoveFileFromList = (index) => {
    const fileToRemove = photosToList[index];

    const updatedPhotosList = [...photosToList];
    updatedPhotosList.splice(index, 1);
    setPhotosToList(updatedPhotosList);

    const photosIndex = photos.findIndex(
      (p) => p.name === fileToRemove.name && p.size === fileToRemove.size
    );
    if (photosIndex !== -1) {
      handleRemovePhotoFile(fileToRemove);
    }
  };

  const handleRemoveUrlPhoto = (index) => {
    const urlPhoto = addItemPhotosArr[index];
    const tmpPhotos = [...addItemPhotosArr];
    tmpPhotos.splice(index, 1);
    dispatch(setUrlPhotos(tmpPhotos));

    removePrintArea(urlPhoto.url);

    if (displayPhoto?.type === "url" && displayPhoto?.id === index) {
      dispatch(setDisplayPhoto(null));
    }
    if (displayPhoto?.type === "url" && displayPhoto?.id === urlPhoto?.url) {
      dispatch(setDisplayPhoto(null));
    }
  };

  const handleAddAiPhoto = (aiPhotoUrl) => {
    const updatedPhotos = [...addItemPhotosArr, { url: aiPhotoUrl }];
    dispatch(setUrlPhotos(updatedPhotos));
  };

  const handleRemoveAiPhoto = (aiPhotoUrl) => {
    const aiIndex = addItemPhotosArr.findIndex((p) => p.url === aiPhotoUrl);
    if (aiIndex === -1) return;

    const updatedPhotos = addItemPhotosArr.filter((p) => p.url !== aiPhotoUrl);
    dispatch(setUrlPhotos(updatedPhotos));

    removePrintArea(aiPhotoUrl);

    if (displayPhoto?.type === "ai" && displayPhoto?.id === aiPhotoUrl) {
      dispatch(setDisplayPhoto(null));
    }
  };

  const validation = () => {
    if (!name || !price || !arabicName) {
      openToast(toastId, "add-item", "warning", t("please-fill-all-inputs"));
    } else if (photos.length === 0 && addItemPhotosArr.length === 0) {
      openToast(toastId, "add-item", "warning", t("please-upload-photos"));
    } else if (displayPhoto === null) {
      openToast(
        toastId,
        "add-item",
        "warning",
        t("please-select-display-photo")
      );
    } else {
      onNext();
    }
  };

  const handleEnhanceAi = async () => {
    let formData = new FormData();

    if (photosToList && photosToList.length > 0) {
      photosToList.forEach((file) => {
        formData.append("files", file);
      });
      formData.append("realLifeImagePromptText", realLifePrompt);
      formData.append("packagingPromptText", packagingPrompt);
      formData.append("backgroundPromptText", backgroundPrompt);

      setGenerateLoading(true);
      dispatch(generateItemPhotos(formData))
        .unwrap()
        .then((data) => {
          if (data?.data) {
            const responseDescription = data.data.description;
            if (responseDescription?.englishName) {
              dispatch(setName(responseDescription.englishName));
            }
            if (responseDescription?.arabicName) {
              dispatch(setArabicName(responseDescription.arabicName));
            }
            if (responseDescription?.englishDesc) {
              dispatch(setDescription(responseDescription.englishDesc));
            }
            if (responseDescription?.arabicDesc) {
              dispatch(setArabicDescription(responseDescription.arabicDesc));
            }
            if (data?.data?.images && data?.data?.images.length) {
              dispatch(setItemAIPhotos(data.data.images));
              setGenerateLoading(false);
            }
          }
        })
        .catch((err) => {
          console.log(err);
          setGenerateLoading(false);
        });
    } else {
      openToast(toastId, "add-item", "warning", t("please-upload-photos"));
    }
  };

  const handleGenerateAIDescription = async () => {
    let body = {};

    if (aIPhotos && aIPhotos.length > 0) {
      body = {
        images: [...aIPhotos],
      };
    } else if (photosToList && photosToList.length > 0) {
      body = new FormData();
      photosToList.forEach((file) => {
        body.append("files", file);
      });
    } else {
      openToast(toastId, "add-item", "warning", t("please-upload-photos"));
      return;
    }

    setGenerateDescriptionLoading(true);

    dispatch(generateItemDescription(body))
      .unwrap()
      .then((data) => {
        if (data?.data) {
          const responseDescription = data.data.description;
          if (responseDescription?.englishName) {
            dispatch(setName(responseDescription.englishName));
          }
          if (responseDescription?.arabicName) {
            dispatch(setArabicName(responseDescription.arabicName));
          }
          if (responseDescription?.englishDesc) {
            dispatch(setDescription(responseDescription.englishDesc));
          }
          if (responseDescription?.arabicDesc) {
            dispatch(setArabicDescription(responseDescription.arabicDesc));
          }
        }
        setGenerateDescriptionLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setGenerateDescriptionLoading(false);
      });
  };

  return (
    <>
      <ContentContainer>
        <RowInputLast>
          <Text>{t("attach-photos")}:</Text>
          <UploadButton htmlFor="fileInput">
            <Upload />
            {t("upload-file")}

            <input
              type="file"
              id="fileInput"
              multiple
              accept="image/*"
              onChange={(e) => {
                handleFileUpload(e.target.files);
              }}
              style={{ display: "none" }}
            />
          </UploadButton>
        </RowInputLast>

        <UploadedPhotosContainer>
          {urlPhotosToList?.map((file, i) => (
            <UploadCard key={i}>
              <HeaderCard>
                <LeftIcons>
                  {displayPhoto?.type === "url" &&
                  displayPhoto?.id === file.url ? (
                    <>
                      <Checked
                        onClick={() => handleClick(i, "url")}
                        className="pointer"
                      />
                    </>
                  ) : (
                    <Tooltip text={t("display-photo")}>
                      <Unchecked
                        style={{ color: "#484888" }}
                        onClick={() => handleClick(i, "url")}
                        className="pointer"
                      />
                    </Tooltip>
                  )}
                </LeftIcons>
                <UseAnimations
                  onClick={() => handleRemoveUrlPhoto(i)}
                  className="pointer"
                  animation={trash2}
                  size={32}
                  strokeColor="#484888"
                />
              </HeaderCard>
              <Image src={file.url} alt="ItemPhoto" />
            </UploadCard>
          ))}

          {photosToList?.map((file, i) => {
            const exist = photos?.some(
              (p) => p?.name === file.name && p?.size === file.size
            );

            return (
              <UploadCard key={i}>
                <HeaderCard>
                  <LeftIcons>
                    {exist ? (
                      <Checked
                        onClick={() => handleRemovePhotoFile(file)}
                        className="pointer"
                      />
                    ) : (
                      <Tooltip text={t("attach-photo")}>
                        <Unchecked
                          style={{ color: "#484888" }}
                          onClick={() => handleAddPhotoFile(file)}
                          className="pointer"
                        />
                      </Tooltip>
                    )}
                  </LeftIcons>
                  <LeftIcons>
                    {displayPhoto?.type === "file" &&
                    displayPhoto?.id === formatFileID(file) ? (
                      <Checked
                        onClick={() => handleClick(i, "file")}
                        className="pointer"
                      />
                    ) : (
                      <Tooltip text={t("display-photo")}>
                        <Unchecked
                          style={{ color: "#484888" }}
                          onClick={() => handleClick(i, "file")}
                          className="pointer"
                        />
                      </Tooltip>
                    )}
                  </LeftIcons>

                  <UseAnimations
                    onClick={() => handleRemoveFileFromList(i)}
                    className="pointer"
                    animation={trash2}
                    size={32}
                    strokeColor="#484888"
                  />
                </HeaderCard>
                <Image src={URL.createObjectURL(file)} alt="ItemPhoto" />
              </UploadCard>
            );
          })}
        </UploadedPhotosContainer>

        {photosToList && photosToList.length > 0 && (
          <RowInputLast>
            <ButtonGenerate
              disabled={generateLoading}
              onClick={() => {
                if (!generateLoading) {
                  handleEnhanceAi();
                }
              }}
            >
              {t("enhance-with-ai")}
              <AiSvg />
            </ButtonGenerate>
            <ButtonGenerate
              disabled={generateLoading}
              onClick={() => {
                if (!generateLoading) {
                  setOpenPromptModal(true);
                }
              }}
            >
              {t("custom-prompt")}
              <PromptSvg />
            </ButtonGenerate>
            {generateLoading && (
              <div
                style={{
                  color: "#484888",
                  fontFamily: "Avenir",
                  fontSize: 24,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <Loading width={32} height={32} style={{ margin: 0 }} />
                <p>{t("generating-ai-images")}</p>
              </div>
            )}
          </RowInputLast>
        )}

        {!generateLoading && aIPhotos && aIPhotos.length > 0 && (
          <UploadedPhotosContainer>
            {aIPhotos?.map((file, i) => {
              const exist = addItemPhotosArr.some((p) => p.url === file);
              return (
                <UploadCard key={i}>
                  <HeaderCard>
                    <LeftIcons>
                      {exist ? (
                        <Checked
                          onClick={() => handleRemoveAiPhoto(file)}
                          className="pointer"
                        />
                      ) : (
                        <Tooltip text={t("attach-photo")}>
                          <Unchecked
                            style={{ color: "#484888" }}
                            onClick={() => handleAddAiPhoto(file)}
                            className="pointer"
                          />
                        </Tooltip>
                      )}
                    </LeftIcons>
                    <LeftIcons>
                      {displayPhoto?.type === "ai" &&
                      displayPhoto?.id === file ? (
                        <Checked
                          onClick={() => handleClick(i, "ai")}
                          className="pointer"
                        />
                      ) : (
                        <Tooltip text={t("display-photo")}>
                          <Unchecked
                            style={{ color: "#484888" }}
                            onClick={() => handleClick(i, "ai")}
                            className="pointer"
                          />
                        </Tooltip>
                      )}
                    </LeftIcons>
                    <UseAnimations
                      onClick={() => handleRemoveAIPhotoFromDisplay(file)}
                      className="pointer"
                      animation={trash2}
                      size={32}
                      strokeColor="#484888"
                    />
                  </HeaderCard>

                  <Image
                    style={{ cursor: "pointer" }}
                    src={file}
                    alt="ItemPhoto"
                    onClick={() => window.open(file, "_blank")}
                  />
                </UploadCard>
              );
            })}
          </UploadedPhotosContainer>
        )}
        <RowInputLast>
          {((aIPhotos && aIPhotos.length > 0) ||
            (photosToList && photosToList.length > 0)) && (
            <ButtonGenerate
              disabled={generateDescriptionLoading}
              onClick={() => {
                if (!generateDescriptionLoading) {
                  handleGenerateAIDescription();
                }
              }}
            >
              {t("regenerate-descriptions")}
              <AiSvg />
            </ButtonGenerate>
          )}
          {generateDescriptionLoading && (
            <div
              style={{
                color: "#484888",
                fontFamily: "Avenir",
                fontSize: 18,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
              }}
            >
              <Loading width={32} height={32} style={{ margin: 0 }} />
              <p> {t("generating-ai-description")}</p>
            </div>
          )}
        </RowInputLast>
        <ColumnInput>
          <Text>{t("item-name")}:</Text>
          <StyledRow>
            <Relative>
              <Input
                placeholder={t("name")}
                value={name}
                onChange={(e) => {
                  dispatch(setName(e.target.value));
                }}
              />
            </Relative>
            <Relative>
              <Input
                placeholder={t("arabic-name")}
                value={arabicName}
                onChange={(e) => {
                  dispatch(setArabicName(e.target.value));
                }}
              />
            </Relative>
          </StyledRow>
        </ColumnInput>
        <ColumnInput>
          <Text>{t("item-description")}:</Text>
          <StyledRow>
            <Relative>
              <TextArea
                placeholder={t("product-description")}
                value={description}
                rows={4}
                onChange={(e) => {
                  dispatch(setDescription(e.target.value));
                }}
              />
            </Relative>
            <Relative>
              <TextArea
                placeholder={t("arabic-product-description")}
                value={arabicDescription}
                rows={4}
                onChange={(e) => {
                  dispatch(setArabicDescription(e.target.value));
                }}
              />
            </Relative>
          </StyledRow>
        </ColumnInput>
        <ColumnInput style={{ maxWidth: 520, width: "100%" }}>
          <Text>{t("item-price")}:</Text>
          <RowPriceContainer style={{ width: "100%" }}>
            <Input
              style={{ width: "100%" }}
              type="number"
              min="1"
              placeholder={t("price")}
              value={price}
              onChange={(e) => {
                dispatch(setPrice(e.target.value));
              }}
            />
            {price && (
              <PriceWithVatText>
                {`${t("with-vat")} ${priceFormatter(
                  parseFloat(price),
                  true,
                  15
                )})`}
              </PriceWithVatText>
            )}
          </RowPriceContainer>
        </ColumnInput>
      </ContentContainer>
      <Buttons>
        <ButtonBack onClick={onBack}>{t("back")}</ButtonBack>
        <ButtonNext onClick={validation}>{t("next")}</ButtonNext>
      </Buttons>

      <CustomPromptModal
        close={() => setOpenPromptModal(false)}
        open={openPromptModal}
        loading={false}
        onClickAccept={() => {}}
        onClickDecline={() => {}}
        packagingPrompt={packagingPrompt}
        realLifePrompt={realLifePrompt}
        setPackagingPrompt={setPackagingPrompt}
        setRealLifePrompt={setRealLifePrompt}
        setBackgroundPrompt={setBackgroundPrompt}
        backgroundPrompt={backgroundPrompt}
      />
    </>
  );
};

export default AddItemStepItemsInfo;
